import React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";
import { useBrand } from "@webuild-ai/react-auth";

import { useTheme } from "@/hooks/use-theme";

/**
 * Not Found page displayed when a user navigates to
 * a route that doesn't exist.
 */
export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const { brand } = useBrand();
  const { theme } = useTheme();

  const brandColors = theme === "dark" ? brand.colors.dark : brand.colors.light;

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
      <div className="flex flex-col items-center text-center max-w-md">
        {/* Search Icon */}
        <div
          className="flex items-center justify-center w-20 h-20 rounded-full mb-6"
          style={{
            backgroundColor: theme === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)",
          }}
        >
          <Icon
            className="w-10 h-10"
            icon="solar:magnifer-broken"
            style={{ color: brandColors.primary }}
          />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold mb-2" style={{ color: brandColors.primary }}>
          {t("Page Not Found")}
        </h1>

        {/* Message */}
        <p className="text-default-500 mb-8">{t("Page Not Found Message")}</p>
      </div>
    </div>
  );
};
